import { useTranslation } from 'next-i18next';
import { Envelope as EnvelopeIcon, Location as LocationIcon } from '@storefront/lib-global';
import { TypographyStylesType, colours } from '@storefront/lib-global/stylings';
import { CustomFlexibleTextPartial, IconWrapper, LinkButton } from './PdpActionLink.styles';

type PdpActionLinkProps = {
  onClick: () => void;
  testId: string;
  type: 'storeStock' | 'emailMeWhenInStock';
};

export function PdpActionLink({ onClick, testId, type }: PdpActionLinkProps) {
  const { t } = useTranslation('lib-products-common');

  const icon = type === 'storeStock' ? <LocationIcon /> : <EnvelopeIcon />;
  const text = type === 'storeStock' ? t('pdp.find.in.store') : t('pdp.email.me.when.in.stock');

  return (
    <LinkButton onClick={onClick} data-testid={testId}>
      <IconWrapper $isLocationIcon={type === 'storeStock'}>{icon}</IconWrapper>
      <CustomFlexibleTextPartial
        defaultTextColor={colours.BLACK}
        defaultTextSize={TypographyStylesType.CTA_LARGE_SEMIBOLD}
      >
        {text}
      </CustomFlexibleTextPartial>
    </LinkButton>
  );
}
